


// import React, { useEffect, useState } from "react";
// // import css from "../css/notification.module.css";
// import Rightcontainer from "../Components/Rightcontainer";
// import { apiRequest } from "../../apiService/allApi";

// const Notification = () => {
//   const [notifications, setNotifications] = useState([]);
//   const access_token = localStorage.getItem("token");

//   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
//   const nodeMode = process.env.NODE_ENV;

//   const baseUrl =
//     nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

//   // ================= FETCH NOTIFICATIONS =================
//   useEffect(() => {
//     notification_list();
//   }, []);

//   const notification_list = async () => {
//     try {
//       const headers = {
//         Authorization: `Bearer ${access_token}`,
//         "Content-Type": "application/json",
//       };

//       const result = await apiRequest(
//         "list-notification/sendto/all?page=1&limit=10",
//         "GET",
//         null,
//         headers
//       );

//       console.log("API RESPONSE:", result);

//       // handle multiple response shapes
//       const data =
//         result?.results ||
//         result?.data?.results ||
//         result?.data ||
//         [];

//       setNotifications(data);
//     } catch (error) {
//       console.log("ERROR FETCHING NOTIFICATIONS:", error);
//     }
//   };

//   // ================= DATE FORMAT =================
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     return new Date(dateString).toLocaleString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   // ================= UI =================
//   return (
//     <>
//       <div>
//         <div className="leftContainer">
//           <div className="pt-5 mt-4">
//             <div className="Orher_page_main_section">
//               <h2 className="profile_headings mt-4">Notifications</h2>

//               {console.log("notifications:", notifications)}

//               {notifications && notifications.length > 0 ? (
//                 notifications.map((item) => (
//                   <div
//                     className="other_pages_card_main"
//                     key={item?._id}
//                   >
//                     <div>
//                       <h3>{item?.title}</h3>
//                       <p>{item?.bodys}</p>
//                     </div>

//                     <div>
//                       <p>{formatDate(item?.createdAt)}</p>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="leftContainer">
//                   <div
//                     className="cxy flex-column px-4 text-center"
//                     style={{ paddingTop: "30%" }}
//                   >
//                     <img
//                       src={
//                         process.env.PUBLIC_URL +
//                         "/images/nonotification.png"
//                       }
//                       width="220px"
//                       alt="no notification"
//                     />

//                     <div
//                       className={`${css.games_section_title} mt-4`}
//                       style={{ fontSize: "1.2em" }}
//                     >
//                       No notification yet!
//                     </div>

//                     <div
//                       className={`${css.games_section_headline} mt-2`}
//                       style={{ fontSize: "0.85em" }}
//                     >
//                       Seems like you haven’t done any activity yet
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="rightContainer">
//             <Rightcontainer />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Notification;


import React, { useEffect, useState } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import { apiRequest } from "../../apiService/allApi";
import { Bell, Sparkles, Calendar, Clock, AlertCircle } from "lucide-react";

// import "../css/Notification.css";

const Notification = () => {
  const [notifications, setNotifications] = useState([]);
  const access_token = localStorage.getItem("token");

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;

  const baseUrl =
    nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  // ================= FETCH NOTIFICATIONS =================
  useEffect(() => {
    notification_list();
  }, []);

  const notification_list = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      };

      const result = await apiRequest(
        "list-notification/sendto/all?page=1&limit=10",
        "GET",
        null,
        headers
      );

      console.log("API RESPONSE:", result);

      // handle multiple response shapes
      const data =
        result?.results ||
        result?.data?.results ||
        result?.data ||
        [];

      setNotifications(data);
    } catch (error) {
      console.log("ERROR FETCHING NOTIFICATIONS:", error);
    }
  };

  // ================= DATE FORMAT =================
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // ================= UI =================
  return (
    <div className="ce-notification-wrapper leftContainer">
      <div className="ce-notification-container">
        
        {/* Top Hero Banner Card */}
        <div className="ce-notification-hero-card">
          <div className="ce-badge-pill">
            <Sparkles size={13} className="ce-emerald-icon" />
            <span>UPDATES & ALERTS</span>
          </div>
          <h1 className="ce-hero-title">NOTIFICATIONS</h1>
          <p className="ce-hero-sub">
            Stay updated with your latest account and game activities
          </p>
        </div>

        {/* Notifications List Container with Slide Animation */}
        {notifications && notifications.length > 0 ? (
          <div className="ce-notifications-list ce-slide-in-left">
            {notifications.map((item, index) => (
              <div
                className="ce-notification-card"
                key={item?._id || index}
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                <div className="ce-card-header-row">
                  <div className="ce-card-icon-box">
                    <Bell size={18} />
                  </div>
                  <div className="ce-card-title-box">
                    <h3 className="ce-card-title">{item?.title || "Notification"}</h3>
                    <div className="ce-card-date-box">
                      <Clock size={12} className="ce-time-icon" />
                      <span>{formatDate(item?.createdAt)}</span>
                    </div>
                  </div>
                </div>

                <div className="ce-card-body-text">
                  <p>{item?.bodys}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* Empty State Card */
          <div className="ce-empty-notifications-card ce-slide-in-left">
            <div className="ce-empty-icon-wrapper">
              <Bell size={32} className="ce-empty-bell-icon" />
            </div>
            <h3 className="ce-empty-title">No notifications yet!</h3>
            <p className="ce-empty-sub">
              Seems like you haven't done any activity or have no new alerts right now.
            </p>
          </div>
        )}

      </div>

      {/* Right Desktop Sidebar */}
      <div className="rightContainer mobile-hide">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Notification;